import { Context, createContext } from 'react';

let context: Context<Record<string, any>> | null = null;
export const getTreeContext = () => {
  if (!context) {
    context = createContext({});
  }
  return context;
};
